export default {
  Buy: '买房',
  Rent: '租房',
  Sell: '卖房',
  Search: '搜索',
  title: '找到你的梦想家园',
  more: '更多',
  less: '更少',
  userTrustedChoice: '用户信赖的选择',
  servedUsers: '已服务 {num} 名用户',
  plentyOfHouses: '海量房源供您选择',
  getHousesNumber: '全美{num}套房源',
  beingSold: '正在出售的优质房产',
  beingRent: '好房在租',
  moreSelling: '查看更多在售房产',
  moreRenting: '查看更多出租房产',
  entireRent: '整套出租',
  privateRoomRent: '可整租可分租',
  masterBedroomRent: '主卧室友招募中',

  totalRating: '人评分',
  location: '位于',
  floorPlanGalleryAndRoomDetail: '户型图和房间详情',
  roomDetail: '屋内各个房间详情',
  insideFacility: '这些公共设施供您使用',
  moreInfo: '可能还需要了解',
  builtYear: '建造年代',
  showBuiltYear: '{year}年建造',
  showParking: '{num} 停车位',
  showStoreRoom: '{num} 储藏间',
  decoration: '装修风格',
  genderRequired: '性别要求',
  female: '女性',
  male: '男性',
  allowPet: '允许宠物',
  nopets: '不允许',
  orientation: '房屋朝向',
  allowCooking: '允许做饭',
  bondsman: '需要担保人',
  floorType: '楼层',
  elevator: '电梯',
  maxLiving: '最多可居住',
  partitionPanel: '允许隔断',
  minTenancyTerm: '最短租期',
  allowSmoking: '吸烟',
  allowParty: '聚会',
  availableTime: '可入住时间',

  friendly: '欢迎',
  need: '需要',
  west: '西',
  east: '东',
  southEast: '东南',
  european: '欧式',
  allow: '允许',
  notAllow: '不允许',
  notNeed: '不需要',
  low: '低',
  exsit: '有',
  notExist: '没有',
  studio: '工作室',
  week: '每周',
  month: '每月',
  season: '每季',
  year: '每年',

  locatedAt: '位于',
  viewAll: '查看全文',
  collapse: '收起',
  anytime: '可立即入住',
  propertyType: '物业类型',
  entire: '租金',
  wechat: '微信',
  priceDetail: '价格详情',
  free: '无',
  rentPrice: '租金',
  utilitiy: '水电费',
  utilitiyTrue: '包含在房租内',
  utilitiyFalse: '自行缴纳',
  applicationFee: '申请费用',
  hoaFee: 'HOA 费用',
  deposit: '押金',
  noDeposit: '免押金',
  garbageFee: '垃圾费',
  parkingFee: '停车费',
  waterFee: '水费',
  tvFee: '有线电视费用',
  internetFee: '无线网络费用',
  facilityFee: '其他设施费用',
  utilityFee: '水电费',
  including: '包含在租金内',
  selfCare: '自理',
  sqm: '平方米',
  none: '无',
  houseDetail: '房产详情',
  feeDetails: '费用详情',
  school: '学校',
  transportation: '交通设施',
  supermarket: '超市',
  floor: '地板',
  roof: '屋顶',
  totalPriceOfHouse: '房产总价',
  needLoan: '需要贷款',
  fullPayment: '全款购房',
  monthlyExpenditure: '每月支出',
  downPayment: '首付合计',
  floorPlanImage: '户型图',
  justUpdated: '刚刚更新',
  noData: '暂未找到房源',
  hour: '小时',
  day: '天',
  updateBefore: '{num} {unit}前更新',
  communityDetails: '社区详情',
  localSay: '看看当地居民怎么说',
  dataFrom: '所有数据来自Jodi Group实地调查',
  similarSellRecommendations: '相似的出售房产推荐',
  sellingPrice: '售价',
  unitPrice: '单价',
  selectAnAgent: '选择一个经纪人',
  back: '返回',
  scan: '扫一扫添加好友',
  pets: {
    firendly: "允许宠物",
    noPets: "不允许宠物",
  },
  list: {
    entire: '整套',
  },

  filterBar: {
    more: '展开更多',
    less: '收齐',
    city: '城市',
    district: '区域',
    school: '学校',
    propertyType: '物业类型',
    priceRange: '价格区间',
    placeType: '出租类型',
    houseType: '户型',
    elevator: '电梯',
    floor: '楼层',
    inside: '室内设施',
    building: '大楼设施',
    orientation: '房屋朝向',
    decoration: '装修风格',
    payPeriod: '付费周期',
    other: '其他筛选',
    feature: '特色',
    cooling: '制冷',
    heating: '制热',
    construction: 'Construction',
    roof: '屋顶类型',
    foundation: 'Foundation',
    familyType:'Family Type'
  },
  notfound: {
    error: '未找到页面',
    tips: '没有找到您访问的页面，可能原因: 网址失效',
    button: '返回首页',
  },
  commentTitle: '对该房源有疑问？留下你的问题',
  commentBtn: '提交问题',
  commentPlace: '向经纪人提问',
  comment: {
    success: '提交成功',
    fail: '提交失败',
  },
  bookView: '预约看房',
  detailInfo: '详细信息',
  viewAllQA: '查看全部 {num} 条提问',
  viewAlbum: '查看相册',
  noLimitPrice: '不限',
  viewPicture: '查看大图',
  whatThinkOf: '觉得这套房子怎么样？打个分吧',
  hasRated: '已经评过分',
  submitRates: '提交分数',
  rates: '人评分',
  agentRate: '经纪人评分',
  userRate: '用户评分',
  hasQuestioned: '今天已经提问过了，如果还有疑问请联系经纪人',
  any: '不限',
  decorationStyle: {
    simple: '简单装修',
    fancy: '豪华装修',
    european: '欧式简约',
  },
  loanLang: {
    interestRate: '贷款利率',
    mortgagePeriod: '贷款期限',
    downPaymentRate: '首付比例',
    years: '年',
  },
  feeLang: {
    propertyTaxes: '不动产税',
    HOA: '物业费',
    insurance: '业主保险',
    mortgageInsurance: '贷款保险',
  },
  houseType: {
    condo: '公寓大厦',
    home: 'Home',
    apartment: '公寓',
    townHouse: '市内宅邸',
    multiUnits: '公寓楼',
  }
}
